import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { FormattedMessage } from 'react-intl';
import useDataSourceContext from '../DataSource/useDataSourceContext';
import translations from './translations';
import styled from 'styled-components';
import clsx from 'clsx';

const DataGridSelectionToolbarContainer = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
`;

const DataGridSelectionToolbarInner = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  padding: ${props => props.theme.spacing(2)}px;
  background: #999;
  color: #fff;
`;

const SelectAllButton = styled(Button)`
  && {
    color: #fff;
    border-color: #fff;
    padding: ${props => props.theme.spacing() / 4}px;
    text-transform: uppercase;
    margin-left: ${props => props.theme.spacing(3)}px;
    margin-right: ${props => props.theme.spacing(3)}px;

    &.active {
      background-color: #fff;
      color: #999;
    }
  }
`;

const BulkActionContainer = styled.div`
  color: #fff;
  border-left: 1px solid #fff;
`;

const DataGridSelectionToolbar = ({ bulkActions }) => {
  const intl = useIntl();
  const dataSource = useDataSourceContext();
  const { data, selection = {}, pagination = {} } = dataSource;
  const {
    allItemsSelected,
    allowSelectAll,
    deselectedItems,
    selectedItems,
    selectItems,
    setAllItemsSelected,
  } = selection;
  const { itemCount = data.length } = pagination;

  const allLabel = intl.formatMessage(translations.selection.button.all);
  let countLabel = itemCount === selectedItems.length ? allLabel : selectedItems.length;

  if (allItemsSelected) {
    countLabel = deselectedItems.length ? itemCount - deselectedItems.length : allLabel;
  }

  /**
   * Handle select all data.
   */
  const handleSelectAll = () => {
    const selectAll = !allItemsSelected;

    setAllItemsSelected(selectAll);
    selectItems(selectAll ? data.map(item => item.id) : []);
  };

  return (
    <DataGridSelectionToolbarContainer>
      <DataGridSelectionToolbarInner>
        <Box mr={allowSelectAll ? 0 : 4}>
          <FormattedMessage
            {...translations.selection.selected}
            values={{ count: countLabel, total: itemCount }}
          />
        </Box>
        {allowSelectAll && (
          <SelectAllButton
            variant="outlined"
            size="small"
            onClick={handleSelectAll}
            className={clsx({ active: allItemsSelected })}
          >
            {allLabel}
          </SelectAllButton>
        )}
        {bulkActions && (
          <BulkActionContainer>
            {bulkActions.map(action => action.render(dataSource))}
          </BulkActionContainer>
        )}
      </DataGridSelectionToolbarInner>
    </DataGridSelectionToolbarContainer>
  );
};

DataGridSelectionToolbar.propTypes = {
  bulkActions: PropTypes.array,
};

DataGridSelectionToolbar.defaultProps = {
  bulkActions: [],
};

export default DataGridSelectionToolbar;
